<template lang="html">
  <div class="vid-int-noWebcam">
    <div class="vid-int-noWebcam__inner vid-int-noWebcam__message">
        <div class="vid-int-noWebcam__item vid-int-noWebcam__title">
            {{ $tr('videoInterview.test.timeIsOver.title') }}
        </div>
        <div class="vid-int-noWebcam__item vid-int-noWebcam__content">
            {{ $tr('videoInterview.test.timeIsOver.content') }}
        </div>
        <div class="vid-int-noWebcam__item vid-int-noWebcam__content">
            <a href="#" @click="complete">{{ $tr('videoInterview.test.timeIsOver.goToNextStep') }}</a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'interview-test-time-is-over',
  methods: {
    complete () {
      this.$emit('complete')
    }
  }
}
</script>

<style scoped>
    .vid-int-noWebcam {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 17px;
        background-color: #f2f2f2;
        padding: 30px 30px 30px 40px;
        min-height: 450px;
        max-width: 1000px;
        margin-left: auto;
        margin-right: auto;
    }

    .vid-int-noWebcam__message {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        width: 400px;
    }

    .vid-int-noWebcam__img-container {
        width: 400px;
    }

    .vid-int-noWebcam__img {
        max-width: 100%;
        height: auto;
        border: 13px solid #ffffff;
    }

    .vid-int-noWebcam__inner {
        margin-right: 50px;
    }

    .vid-int-noWebcam__inner:last-child {
        margin-right: 0;
    }

    .vid-int-noWebcam__item {
        margin-bottom: 30px;
    }

    .vid-int-noWebcam__item:last-child {
        margin-bottom: 0;
    }

    .vid-int-noWebcam__title {
        color: #49bc00;
    }
</style>
